import { FC } from 'react';

interface TermItemProps {
  title: string;
  content: string;
}
const TermItem: FC<TermItemProps> = ({ title, content }) => {
  return (
    <>
      <p className="text-xl break-all leading-normal font-bold text-gray900 mb-5 whitespace-normal  ">
        {title}
      </p>
      <p className=" leading-normal tracking-wide text-gray800  whitespace-pre-wrap mb-6 ">{content}</p>
    </>
  );
};
export type rulesType = {
  title: string;
  content: string;
}[];
export default TermItem;
